import { styled } from '@mui/material';

const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const TimeChip = styled('span')(({ theme }) => ({
  position: 'relative',
  background: theme.palette.box.tertiary,
  fontSize: theme.typography.textXs.fontSize,
  padding: theme.spacing(3, 5),
  borderRadius: '24px',
  backgroundClip: 'padding-box',
  border: '1px solid transparent',
  letterSpacing: '20%',
  display: 'inline-block',
  lineHeight: 1.15,
  '&:before': {
    content: "''",
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: '-1',
    margin: '-1px', // Size of the border
    borderRadius: 'inherit',
    background: `linear-gradient(to bottom, ${theme.palette.primary.main}, #185A5B00)`,
  },
}));

export const CountdownChip = ({ secondsLeft }: { secondsLeft: number }) => {
  return <TimeChip>{formatTime(secondsLeft)}</TimeChip>;
};
